const Routes = {
  Connection: {
    SignIn: '/sign-in',
    Welcome: '/welcome',
    WelcomePetsitting: '/welcome-petsitting',
    PasswordForgotten: '/password-forgotten',
    PasswordEmailSent: '/password-email-sent',
    ConnectionLink: '/connection-link',
    ConnectionLinkSended: '/connection-link-sended',
    ResetPassword: (token: string) => `/password-forgotten/${token}`,
    SignUp: {
      Type: '/sign-up',
      Details: '/sign-up/details',
    },
    CreateAccount: {
      AddPet: '/create-your-profile/add-pet',
      AddressPhoto: '/create-your-profile/address-photo',
      Description: '/create-your-profile/description',
      Availability: '/create-your-profile/availability',
      Dogs: '/create-your-profile/dogs',
      Partners: '/create-your-profile/partners',
      Favorites: '/create-your-profile/favorites',
      SignUpCallRequest: '/sign-up-call-request',
    },
  },
  Home: '/home',
  CreateRequest: {
    Base: '/create-request',
    Confirmation: '/create-request/confirmation',
  },
  CreateMission: {
    Base: '/create-mission',
    Confirmation: '/create-mission/confirmation',
  },
  Search: {
    _pathname: '/search',
    _params: {
      ByDate: { order: 'date' },
    },
  },
  Profile: (customerId: string) => `/view-profile/${customerId}`,
  ProfilePetSitter: (customerId: string) => `/view-profile-petsitter/${customerId}`,
  PublicProfilePetSitter: (customerId: string) => `/view-public-profile-petsitter/${customerId}`,
  PublicProfile: (customerId: string) => `/view-public-profile/${customerId}`,
  Message: {
    _pathname: '/message',
    _params: {
      Profile: (profileId: string) => ({
        profile: profileId,
      }),
    },
  },
  Favorites: {
    _pathname: '/favorites',
    _params: {
      Sent: { mode: 'sent' },
      Received: { mode: 'received' },
      Mutual: { mode: 'mutual' },
    },
  },
  PetSitter: {
    // Base: '/pet-sitter',
    Base: '/pet-sitter/search',
    Search: '/pet-sitter/search',
    Reservations: {
      Base: '/pet-sitter/reservations',
      Payment: `/pet-sitter/reservations/payment`,
      PaymentCall: `/pet-sitter/reservations/payment-call`,
      NewRequest: '/pet-sitter/reservations/new-request',
    },
    Reservation: (reservationId: string) => `/pet-sitter/reservation/${reservationId}`,
    Tenders: (tenderId: string) => `/pet-sitter/tenders/${tenderId}`,
  },
  Pro: {
    Dashboard: '/pro',
    Reservations: '/pro/reservations',
    Services: '/pro/my-services',
    Reservation: (reservationId: string) => `/pro/reservation/${reservationId}`,
    Tenders: (tenderId: string) => `/pro/tenders/${tenderId}`,
    Missions: '/pro/missions',
    Mission: (missionId: string) => `/pro/missions/${missionId}`,
    MyProfile: '/pro/my-profile',
    Safety: '/pro/safety',
    Contact: '/pro/contact',
    Assistance: '/pro/assistance',
    SignUp: {
      CompleteProfile: '/pro/sign-up/complete-profile',
      Experience: '/pro/sign-up/experience',
      Services: '/pro/sign-up/services',
      Psychology: '/pro/sign-up/psychology',
      Knowledge: '/pro/sign-up/knowledge',
      Identity: '/pro/sign-up/identity',
    },
    MyAccount: {
      settings: '/pro/my-account',
      disableRenewal: {
        index: '/pro/my-account/disable-renewal/',
        step1: '/pro/my-account/disable-renewal/step1',
        step2: '/pro/my-account/disable-renewal/step2',
        step3: '/pro/my-account/disable-renewal/step3',
      },
      deleteAccount: {
        index: '/pro/my-account/delete-account',
        step2: '/pro/my-account/delete-account/step2',
        step3: '/pro/my-account/delete-account/step3',
        step4: '/pro/my-account/delete-account/step4',
      },
      disableAccount: {
        index: '/pro/my-account/disable-account',
        step2: '/pro/my-account/disable-account/step2',
        step3: '/pro/my-account/disable-account/step3',
      },
    },
  },
  MyProfile: '/my-profile',
  MyPetProfile: (petId: string) => `/my-pet-profile/${petId}`,
  MyAccount: {
    settings: '/my-account',
    disableRenewal: {
      index: '/my-account/disable-renewal/',
      step1: '/my-account/disable-renewal/step1',
      step2: '/my-account/disable-renewal/step2',
      step3: '/my-account/disable-renewal/step3',
    },
    deleteAccount: {
      index: '/my-account/delete-account',
      step2: '/my-account/delete-account/step2',
      step3: '/my-account/delete-account/step3',
      step4: '/my-account/delete-account/step4',
    },
    disableAccount: {
      index: '/my-account/disable-account',
      step2: '/my-account/disable-account/step2',
      step3: '/my-account/disable-account/step3',
    },
  },
  Contact: '/contact',
  Assistance: '/assistance',
  Safety: '/safety',
  Partners: '/partners',
  EmergencyPetCareRelay: '/emergency-pet-care-relay',
  Premium: {
    Base: '/premium',
    Select: '/premium/select',
    Payment: '/premium/payment',
    Success: '/premium/success',
  },
  IDCheck: {
    Base: '/id-check',
    Send: {
      _pathname: '/id-check/send',
      _params: {
        IDCard: { mode: 'id-card' },
        Passport: { mode: 'passport' },
      },
    },
    Manual: '/id-check/manual',
    End: '/id-check/end',
  },
  Ghost: {
    paypal: '/ghost/paypal',
  },
  Testimony: '/testimony',
}

export default Routes
